module.exports = __webpack_public_path__ + "static/media/integration.599ad97f.png";